import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// El backend responde { data, state, message }: un fallo de negocio llega con
// state=false y HTTP 200, así que se convierte en excepción para el toast.
const resultado = (data) => {
  if (data?.state === false) throw new Error(data?.message || 'No fue posible completar la acción');
  return data?.data;
};

export const getNominas = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/nomina`, { params });
  return resultado(data) || [];
};

export const getNomina = async (id) => {
  const { data } = await axios.get(`${API_URL}/nomina/${id}`);
  return resultado(data);
};

export const getSugerenciaNomina = async (params) => {
  const { data } = await axios.get(`${API_URL}/nomina/sugerencia`, { params });
  return resultado(data);
};

export const crearNomina = async (payload) => {
  const { data } = await axios.post(`${API_URL}/nomina`, payload);
  return resultado(data);
};

export const recalcularNomina = async (id) => {
  const { data } = await axios.post(`${API_URL}/nomina/${id}/recalcular`);
  return resultado(data);
};

export const actualizarLineaNomina = async (id, lineaId, payload) => {
  const { data } = await axios.patch(`${API_URL}/nomina/${id}/lineas/${lineaId}`, payload);
  return resultado(data);
};

// accion: aprobar | reabrir | pagar | anular
export const cambiarEstadoNomina = async (id, accion, payload = {}) => {
  const { data } = await axios.post(`${API_URL}/nomina/${id}/${accion}`, payload);
  return resultado(data);
};

export const eliminarNomina = async (id) => {
  const { data } = await axios.delete(`${API_URL}/nomina/${id}`);
  return resultado(data);
};

export const getParametrosNomina = async () => {
  const { data } = await axios.get(`${API_URL}/nomina-parametros`);
  return resultado(data);
};

export const actualizarParametrosNomina = async (payload) => {
  const { data } = await axios.patch(`${API_URL}/nomina-parametros`, payload);
  return resultado(data);
};

// Sedes para filtrar la nómina. Las lavanderías guardan estado 'Activo' (no 'Activa').
export const getSedesNomina = async () => {
  const { data } = await axios.post(`${API_URL}/laundry/filter`, {
    limit: 1000,
    offset: 1,
    query: { estado: 'Activo' },
  });
  const lista = Array.isArray(data?.data) ? data.data : [];
  return lista
    .map((s) => ({ id: s._id, nombre: s.nombre }))
    .sort((a, b) => String(a.nombre).localeCompare(String(b.nombre)));
};
